import React, { Component } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import API from "../../../src/apiService";
import { Select2Nolabel as SelectMultiple } from 'view/component/FormFormik';
import Alert from "../component/Alert";

const SignupSchema = Yup.object().shape({
  name: Yup.string().required("Nama harus diisi"),
});

export default class ModalAddRoleAccess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        id: this.props.roleaccessdata !== null ? this.props.roleaccessdata.id : "",
        name: this.props.roleaccessdata !== null ? this.props.roleaccessdata.name : "",
      },
      refaccessdata: this.props.refaccessdata,
      selected: this.props.roleaccessdata?.ref_access?.map(v => ({label: v.access.name, value: v.access.id})) ?? [],
    };
  }

  componentDidUpdate(prevProps, _, __) {
    if (prevProps.roleaccessdata !== this.props.roleaccessdata) {
      this.setState({
        data: this.props.roleaccessdata,
        selected: this.props.roleaccessdata?.ref_access?.map(v => ({label: v.access.name, value: v.access.id})) ?? [],
      });
    }
    if (prevProps.refaccessdata !== this.props.refaccessdata) {
      this.setState({ refaccessdata: this.props.refaccessdata });
    }
  }

  onChange = (event) => {
    const value = event.target.value;
    const object = event.target.name;
    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        [object]: value,
      },
    }));
  };

  resetData() {
    this.setState({
      data: {
        id: "",
        name: "",
      },
      selected: []
    });
  }

  postData = async () => {
    const res = await API.post("config/role_access/assign", {
      role_id: this.state.data.id,
      access_id: this.state.selected.map(v => v.value)
    });
    if (res.code === 200) {
      Alert("success", "Berhasil mengedit akses");
      this.props.onHide();
      this.props.refreshdata();
      this.resetData();
    }
  };

  render() {
    return (
      <Modal
        show={this.props.show}
        size={'lg'}
        aria-labelledby="modal-user"
        onHide={() => {
          this.props.onHide();
          this.resetData();
        }}
      >
        <ModalHeader closeButton>
          <ModalTitle>
            <h3>Edit Data Role Access</h3>
          </ModalTitle>
        </ModalHeader>
        <Formik
          enableReinitialize
          initialValues={{
            name: this.state.data.name,
          }}
          validationSchema={SignupSchema}
          onSubmit={(values) => {
            this.postData();
          }}
        >
          {({ values, errors, touched }) => (
            <Form>
              <ModalBody>
                <div className="form-group row">
                  <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                  >
                    Role
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <input
                        className="form-control form-control-sm"
                        type="text"
                        placeholder="Nama medis/paramedis"
                        name="name"
                        id="name"
                        value={values.name}
                        onChange={this.onChange}
                        readOnly={true}
                      />
                      {errors.name && touched.name ? (
                        <div style={{ color: "red" }}>{errors.name}</div>
                      ) : null}
                    </div>
                  </div>
                </div>
                <SelectMultiple
                    name="village"
                    onChange={(e) => this.setState({selected: e})}
                    value={this.state.selected}
                    errors={''}
                    touched={''}
                    icon="ni ni-circle-08"
                    type="text"
                    isMulti
                    option={this.state.refaccessdata.map(v => ({label: v.name, value: v.id}))}
                />
                <div style={{height: 400}}/>
              </ModalBody>
              <ModalFooter>
                <div className="row">
                  <div className="col-12">
                    <button
                      type="button"
                      onClick={() => {
                        this.props.onHide();
                        this.resetData();
                      }}
                      className="btn btn-outline-secondary"
                    >
                      Batal
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </Modal>
    );
  }
}
